import { useState } from 'react'
import { Box, Flex, Heading, Text, VStack, Input, Button, FormControl, FormLabel, useToast } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { useAdminAuth } from '../App'
import { Shield } from 'lucide-react'

export default function AdminLogin() {
  const [form, setForm] = useState({ email: '', password: '' })
  const [loading, setLoading] = useState(false)
  const { login } = useAdminAuth()
  const navigate = useNavigate()
  const toast = useToast()

  const handleSubmit = async () => {
    setLoading(true)
    try {
      await login(form.email, form.password)
      navigate('/')
    } catch (e) {
      toast({ title: e.response?.data?.detail || 'Access denied', status: 'error', duration: 4000 })
    } finally { setLoading(false) }
  }

  return (
    <Flex minH="100vh" bg="#0A1F44" align="center" justify="center" p={8}>
      <Box bg="white" borderRadius="16px" p={10} w="full" maxW="380px" boxShadow="xl">
        <VStack spacing={1} mb={8}>
          <Box bg="brand.orange" borderRadius="10px" p={3} mb={3}><Shield size={24} color="white" /></Box>
          <Heading size="lg" fontFamily="Georgia, serif" color="brand.darkBlue">Admin Access</Heading>
          <Text fontSize="13px" color="gray.500">WriteMills Administration Panel</Text>
        </VStack>
        <VStack spacing={4}>
          <FormControl>
            <FormLabel fontSize="13px" fontWeight="500" color="gray.600">Admin Email</FormLabel>
            <Input value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} type="email" borderColor="#E2E2E2" _focus={{ borderColor: 'brand.orange', boxShadow: '0 0 0 1px #E87300' }} onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
          </FormControl>
          <FormControl>
            <FormLabel fontSize="13px" fontWeight="500" color="gray.600">Password</FormLabel>
            <Input value={form.password} onChange={e => setForm(p => ({ ...p, password: e.target.value }))} type="password" borderColor="#E2E2E2" _focus={{ borderColor: 'brand.orange', boxShadow: '0 0 0 1px #E87300' }} onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
          </FormControl>
          <Button variant="primary" w="full" size="lg" onClick={handleSubmit} isLoading={loading}>Sign In</Button>
        </VStack>
      </Box>
    </Flex>
  )
}
